export const SET_LOCALE_STATE = '@intl/SET_LOCALE_STATE';
export const SET_LOCALE = '@intl/SET_LOCALE';
export const SET_LOCALE_DEVTOOL = '@intl/SET_LOCALE_DEVTOOL';
export const SET_LOCALE_START = '@intl/SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = '@intl/SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = '@intl/SET_LOCALE_ERROR';
export const UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS = '@intl/UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS';
//# sourceMappingURL=constants.js.map